<p-dialog
  [(visible)]="visible"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [closeOnEscape]="true"
  [style]="{width: '900px', height: '600px'}"
  styleClass="p-dialog-utente-modifica"
  [showHeader]="true"
  (onHide)="onHide()">

  <ng-template pTemplate="header">
    <div class="header-content">
      <span class="material-icons" style="vertical-align: middle; margin-right: 8px; font-size: 28px;">person</span>
      <span>{{ isNew ? 'Crea Utente' : 'Modifica Utente' }}</span>
    </div>
  </ng-template>

  <div class="dialog-container">
    <form [formGroup]="form" (ngSubmit)="onSubmit()" class="dialog-content">
      <div class="grid">
        <div class="col-12">
          <div style="display: flex; gap: 1rem;">
            <div style="flex: 0.8;">
              <div class="field">
                <label for="nome">Nome</label>
                <input
                  id="nome"
                  type="text"
                  pInputText
                  formControlName="nome"
                  [ngClass]="{ 'ng-invalid ng-dirty': form.get('nome')?.invalid && form.get('nome')?.touched }"
                />
                <small class="p-error" *ngIf="form.get('nome')?.invalid && form.get('nome')?.touched">
                  Il nome è obbligatorio
                </small>
              </div>
            </div>

            <div style="flex: 1.2;">
              <div class="field">
                <label for="mail">Email</label>
                <input
                  id="mail"
                  type="email"
                  pInputText
                  formControlName="email"
                  [ngClass]="{ 'ng-invalid ng-dirty': form.get('email')?.invalid && form.get('email')?.touched }"
                />
                <small class="p-error" *ngIf="form.get('email')?.invalid && form.get('email')?.touched">
                  <span *ngIf="form.get('email')?.errors?.['required']">L'email è obbligatoria</span>
                  <span *ngIf="form.get('email')?.errors?.['email']">Inserisci un'email valida</span>
                </small>
              </div>
            </div>
          </div>
        </div>

        <div class="col-12" *ngIf="isNew">
          <div class="field">
            <label for="password">Password</label>
            <p-password
              id="password"
              formControlName="password"
              [toggleMask]="true"
              [feedback]="true"
              [promptLabel]="'Inserisci una password'"
              [weakLabel]="'Password troppo debole'"
              [mediumLabel]="'Password media'"
              [strongLabel]="'Password forte'"
              [ngClass]="{ 'ng-invalid ng-dirty': form.get('password')?.invalid && form.get('password')?.touched }"
              placeholder="Inserisci la password"
              [style]="{'width': '100%'}"
            ></p-password>
            <small class="p-error" *ngIf="form.get('password')?.invalid && form.get('password')?.touched">
              La password deve contenere almeno 8 caratteri, lettere maiuscole, minuscole, numeri e simboli
            </small>
          </div>
        </div>

        <div class="col-12">
          <div style="display: flex; gap: 1rem;">
            <div style="flex: 1;">
              <div class="field">
                <label for="ruolo">Ruolo</label>
                <p-dropdown
                  id="ruolo"
                  [options]="ruoli"
                  formControlName="ruolo"
                  optionLabel="descrizione"
                  [ngClass]="{ 'ng-invalid ng-dirty': form.get('ruolo')?.invalid && form.get('ruolo')?.touched }"
                  placeholder="Seleziona un ruolo"
                  appendTo="body"
                ></p-dropdown>
                <small class="p-error" *ngIf="form.get('ruolo')?.invalid && form.get('ruolo')?.touched">
                  Il ruolo è obbligatorio
                </small>
              </div>
            </div>

            <div style="flex: 1;">
              <div class="field">
                <label for="enteEsecutore">Ente Esecutore</label>
                <p-dropdown
                  id="enteEsecutore"
                  [options]="enti"
                  formControlName="enteEsecutore"
                  optionLabel="label"
                  placeholder="Seleziona un ente"
                  appendTo="body"
                ></p-dropdown>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>

    <!-- Separatore -->
    <div class="separator"></div>

    <!-- Footer del dialog -->
    <div class="dialog-footer">
      <button
        pButton
        pRipple
        label="Annulla"
        icon="pi pi-times"
        class="p-button-outlined p-button-secondary"
        (click)="onHide()">
      </button>
      <button
        pButton
        pRipple
        label="Salva"
        icon="pi pi-check"
        class="p-button-primary"
        [disabled]="!isFormValid()"
        (click)="onSubmit()">
      </button>
    </div>
  </div>
</p-dialog>

<!-- Toast per notifiche -->
<p-toast position="top-right"></p-toast>
